import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ReactiveFormsModule} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingCarga, ITrackingDocumentos, ITrackingViajeByChofer, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer } from '../../../traslado-logist/model/model';
import { ComedorService } from 'src/app/aplicaciones-modulos/comedor/services/comedor.services';
import { ColDef } from 'ag-grid-community';
import { forkJoin } from 'rxjs';
import { IParametroLogistica } from '../../model/parametro-logistica.model';
import { dateGreaterThanValidator } from 'src/app/shared/validators/notWhiteSpacesValidator';

@Component({
  selector: 'app-tracking-convoy',
  templateUrl: './tracking-convoy.component.html',
  styleUrls: ['./tracking-convoy.component.css']
})

export class TrackingConvoyComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.convoy;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;
  public DAT_BTNCSS     = diccionarios.button.buttonsCss;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // Variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : any[] = [];
  public rowSelection   : any;

  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;
  public defaultColDef  : ColDef;

  // Variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : any[] = [];
  public selected       : any;

  public listViajes     : ITrackingViajes [] = [];

  //esta para usar para listar los viajes ya asigandos
  public listViajesAsignados:  ITrackingViajes [] = [];

  public listAsignaciones : any[] = [];
  public tablaCelds     : any;
  public fechaHoraInicio : any;
  public listConvoysParametro: IParametroLogistica[] = [];
  private listConvoysParametroRespaldo: IParametroLogistica[] | null = null;
  private observacionTemporalAgregada: boolean = false;
  public listViajesByChofer: ITrackingViajeByChofer[] = [];
  public listChoferesDropdown: Array<ITrackingViajeByChofer & { display: string }> = [];
  public selectedChoferViajeId: number | null = null;

  public formulario = new FormGroup({
    idConvoy          : new FormControl(''),
    observacion       : new FormControl('', Validators.maxLength(400)),
    estado            : new FormControl('', Validators.required),
    creadoPor         : new FormControl('', Validators.required),
    modificadoPor     : new FormControl(''),
    creado            : new FormControl(''),
    grupo             : new FormControl('', [Validators.required, Validators.maxLength(100)]),  //Feat T.42031 7.2
    fechaLlegada      : new FormControl(''),
    fechaSalida       : new FormControl('', Validators.required),  //Feat T.42031 7.1
    }, { validators: dateGreaterThanValidator('fechaLlegada', 'fechaSalida') });

  public formDetalle = new FormGroup({
    viajeId       : new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(4), Validators.pattern('^[0-9]*$')]),
    convoyId      : new FormControl(''),
    esLider       : new FormControl(false),
    viajeDetalle  : new FormControl('', Validators.required),
    placa         : new FormControl(''),
    furgon        : new FormControl(''),
    nombreProveedor: new FormControl(''),
    choferNombre  : new FormControl(''),
    });

  constructor(
    private utilServices  : UtilsService,
    private dmaestrosAPI  : DatosMaestrosService,
    private logisticaAPI  : LogisticaService,
    private nominaAPI     : ComedorService,
    private _catalogos    : CatalogosLogisticaService
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.DAT_TITULOS = diccionarios.titulos.convoy;
    this.isCreate = true;

    this.inicializar();
    this.cargarGridcomponent();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = this._catalogos.getColumnDefsConvoy();
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned: "left", width: 100, cellRendererParams: { onClick: this.editar.bind(this), label: 'Editar' } },
      { cellRenderer: 'buttonRenderer', initialPinned: "left", width: 150, cellRendererParams: { onClick: this.cerrarConvoy.bind(this), label: '=> Enviar a Garita' } },
    );

    this.defaultColDef = this._catalogos.getDefaultColDef();
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  inicializar(){
    //this.listTipos    = [];
    //this.listCentros  = [];
    const _getAllCentros = this.dmaestrosAPI.getAllCentroLogistico();
    const _getAllTipos = this.logisticaAPI.getTipos();
    const _getConvoysParam = this.logisticaAPI.getParametrosLogisticaNameByConvoy('TRACK_GENRL_CONVOY');
    const _getViajesByChofer = this.logisticaAPI.getViajesByChofer();

    forkJoin([_getAllCentros, _getAllTipos, _getConvoysParam, _getViajesByChofer]).subscribe((res: any) => {
      this.listCentros = res[0];
      this.listCentros.map(centros => { centros.nombre = centros.id + ' - ' + centros.nombre; });
      this.listTipos = res[1];
      const parametro = Array.isArray(res[2]) ? res[2][0] : res[2];
      this.listConvoysParametro = (parametro && parametro.parametrosHijos)
        ? parametro.parametrosHijos.filter((p: IParametroLogistica) => p.estado === 'A')
        : [];
      this.listViajesByChofer = Array.isArray(res[3]) ? res[3] : [];
      this.listChoferesDropdown = this.listViajesByChofer
        .filter(v => v && v.idViaje != null)
        .map(v => ({ ...v, display: `${v.nombres} - ${v.placa} - #${v.idViaje}` }));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.listTipos = [];
      this.listCentros = [];
      this.listConvoysParametro = [];
      this.listViajesByChofer = [];
      this.listChoferesDropdown = [];
    });

    this.listar();
  }

  private normalizarTexto(valor: any): string {
    return String(valor ?? '').trim();
  }

  private asegurarObservacionEnCombo(observacion: any) {
    const valor = this.normalizarTexto(observacion);
    if (!valor) return;

    const existe = (this.listConvoysParametro || []).some((p: any) => this.normalizarTexto(p?.nombreParametro) === valor);
    if (existe) return;

    if (!this.listConvoysParametroRespaldo) {
      this.listConvoysParametroRespaldo = [...(this.listConvoysParametro || [])];
    }

    const temporal = { nombreParametro: valor, estado: 'A' } as any as IParametroLogistica;
    this.listConvoysParametro = [...(this.listConvoysParametro || []), temporal];
    this.observacionTemporalAgregada = true;
  }

  private restaurarObservacionCombo() {
    if (this.observacionTemporalAgregada && this.listConvoysParametroRespaldo) {
      this.listConvoysParametro = [...this.listConvoysParametroRespaldo];
    }
    this.listConvoysParametroRespaldo = null;
    this.observacionTemporalAgregada = false;
  }

  onChoferChange(event: any) {
    const idViaje = (event && typeof event === 'object' && event.idViaje != null) ? event.idViaje : event;
    if (!idViaje) return;
    this.selectedChoferViajeId = idViaje;
    const selected = this.listChoferesDropdown.find(x => x.idViaje === idViaje);
    if (selected) {
      this.formDetalle.patchValue({
        viajeId: idViaje,
        placa: selected.placa,
        furgon: selected.furgon,
        nombreProveedor: selected.nombreProveedor,
        choferNombre: selected.nombres,
      });
    }
    //} else {
    this.formDetalle.get('viajeId').setValue(idViaje);
    //}
    this.getViaje();
  }

  nuevo() {
    this.restaurarObservacionCombo();
    this.isCreate   = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();

    this.formulario.reset();
    this.formDetalle.reset();
    this.clearListAsignaciones();

    this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
    this.formulario.get('estado').setValue('ASIGNAR_CONVOY');
    this.formDetalle.get('esLider').setValue(false);

    this.openModal();
  }

  editar({rowData}){
    this.restaurarObservacionCombo();
    this.isCreate  = false;
    this.selected = rowData;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    console.log("registro seleccionado", this.selected);

    this.formulario.reset();
    this.formDetalle.reset();

    this.asegurarObservacionEnCombo(rowData?.grupo); //Feat T.42031 7.2
    this.formulario.patchValue(rowData);
    console.log("rowData", rowData);
    this.formulario.get('modificadoPor').setValue(this.usarioActual.login2);
    this.formulario.patchValue({ idConvoy: rowData.idConvoy });
    this.formDetalle.get('convoyId').setValue(rowData.idConvoy);
    const esLiderVal = Array.isArray(rowData.detalles) && rowData.detalles.length > 0 ? (rowData.detalles[0].esLider == 1 ? true : false) : false;
    this.formDetalle.get('esLider').setValue(esLiderVal);
    console.log("rowData.detalles", rowData.detalles);
    console.log("formDetalle", this.formDetalle.value);
    console.log("formulario", this.formulario.value);
    //this.getProveedor();
    //this.getChofer();
    //this.getAlmacen();
    //this.getDetalles();
    //this.getColaborador();

    this.listAsignaciones = rowData.detalles;
    this.openModal();
  }

  delete({rowData}){
    this.loading = true;

    this.utilServices.confirmarSincronoPromesa({
        title : diccionarios.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.logisticaAPI.deleteViaje(rowData.idViaje),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  listar(){
    this.loading = false;
    this.rowData = null;
    this.logisticaAPI.getConvoyByEstado("ASIGNAR_CONVOY").subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });

    console.log("registros", this.rowData);
  }

  saveForm() {
    //this.getFormValidationErrors();
    if (this.formulario.invalid) {
        this.utilServices.mensajeErroToast("Seleccione el Convoy");
        return;
    }

    if (this.listAsignaciones.length == 0)
      {
        this.utilServices.mensajeErroToast("Falta detalles de Viajes");
        return;
      }

    this.loading  = true;

    let data = this.formulario.getRawValue();
    data.detalles = this.listAsignaciones.map((d) => {
      const detalle = { ...d };
      delete detalle.choferNombre;
      delete detalle.nombreProveedor;
      delete detalle.furgon;
      return detalle;
    });
    const payload =  data;
    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.logisticaAPI.createConvoy(payload) : this.logisticaAPI.updateConvoy(payload)
      }).then(() => {
        if (this.isCreate) {
          this.formulario.reset();
          this.formDetalle.reset();
          this.listAsignaciones = [];
          this.selectedChoferViajeId = null;
        }
        this.listar();
        this.restaurarObservacionCombo();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  cerrarConvoy({ rowData }){
    rowData.estado = 'CONVOY_PLANIFICADO';
    //const estadoActualizar = "CONVOY_PLANIFICADO";
    const data = rowData;

    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea enviar a "+data.estado+" el viaje?",
        text    : 'VIAJE ' + rowData.detalles[0].viajeId,
        action  : "Actualizar Viaje y Cerrar Convoy",
        funcion : this.logisticaAPI.cerrarConvoy(data)
      }).then(() => {
        this.loading = false;
        this.listar();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  enviarMails() {
    const idConvoy = this.formulario.get('idConvoy')?.value;
    if (!idConvoy) {
      this.utilServices.mensajeErroToast('No existe ID Convoy');
      return;
    }

    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
      title: '¿Enviar mails del convoy?',
      text: 'Convoy ' + idConvoy,
      action: 'Enviar mails',
      funcion: this.logisticaAPI.enviarMailsConvoy( idConvoy )
    }).then(() => {
      this.loading = false;
      this.utilServices.mensajeOKToast('Mails enviados');
    }).catch(() => {
      this.loading = false;
    });
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    this.restaurarObservacionCombo();
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  /** METODOS DE CONSULTAS  */
  proveedorSelected;
  getProveedor(){
    let pathParam = this.formulario.get('proveedorId').value;

    this.formulario.get('proveedorNombre').reset();
    this.dmaestrosAPI.getProveedorByID(pathParam).subscribe((res) => {
      if(res){
        this.proveedorSelected = res;
        this.formulario.get('proveedorNombre').setValue(this.proveedorSelected.nombre);;
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
        this.proveedorSelected = null;
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  // En la tabla de placas se encuentra tanto el Furgon como la Placa de cabezal
  getPlaca(isPlaca: boolean = true){
    let pathParam = isPlaca ? this.formulario.get('placa').value : this.formulario.get('furgon').value;

    if(isPlaca){
      this.formulario.get('proveedorId').reset();
      this.formulario.get('detallePlaca').reset();
    }else{
      this.formulario.get('detalleFurgon').reset();
    }

    this.dmaestrosAPI.getPlacabyId(pathParam).subscribe((res: Placa) => {
      if(res){
        if(isPlaca){
          this.formulario.get('proveedorId').setValue(res.cedula);
          this.formulario.get('detallePlaca').setValue(res.marca);
          this.getProveedor();
        }else{
          this.formulario.get('detalleFurgon').setValue(res.marca);
        }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => {
      console.error(err.message);
    });

  }

  getChofer(){
    let pathParam = this.formulario.get('choferCedula').value;
    this.formulario.get('choferNombre').reset();

    this.dmaestrosAPI.getChoferByCedula(pathParam).subscribe((res: Chofer) => {
      if(res){
        this.formulario.get('choferNombre').setValue(res.nombres);
        if(this.isCreate)
          {
            this.formulario.get('choferTelefono').reset();
            this.formulario.get('choferTelefono').setValue(res.fono);
          }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  getAlmacen(idCentro:any = null){
    this.listAgencias = null;
    let pathParam = this.formulario.get('centroOrigen').value;
    console.log("llamando almacenes CENTRO", idCentro);

    this.dmaestrosAPI.getAllAlmacenByCentro(pathParam).subscribe((res) => {
      if(res){
        this.listAgencias = res;
      }else{
        console.log("listar almacenes", res);
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => {
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message);
    });
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;
    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

  getColaborador(){
    let cedula = this.formulario.get('colaboradorLider').value;

    this.nominaAPI.getEmpleadoByCedula(cedula).subscribe((res) => {
      if(res){
        this.formulario.get('colaboradorNombre').setValue(res.nombres);
      }
    }, (err) => {
      this.utilServices.alertifyToastWar("No se encontró colaboador");
      console.log(err.message);
    });
  }

  getViajesDisponibles(){
    this.logisticaAPI.getViajesByEstado('ASIGNAR_CONVOY').subscribe((res) => {
      if(res){
        this.listViajes = res;
      }
    }, (err) => {
      console.log(err.message);
    });

  }

  getViaje(){
    const idViaje = this.formDetalle.get("viajeId").value;
    this.formDetalle.get("viajeDetalle").reset();

      this.logisticaAPI.getViaje(idViaje).subscribe((res) => {
        if(res.estado != 'ASIGNAR_CONVOY') {
          this.utilServices.mensajeErrorVisto("Viaje no asignable en estado " + res.estado);
        }else{
          this.formDetalle.get("viajeDetalle").setValue(res.detalleViaje);
          this.formDetalle.get("placa").setValue(res.placa);
        }

      }, (err) => {
        console.log(err.message);
      });
    }


  /*Metodos para proceso de carga de viajes*/
  addDetalle(){
    if (this.formulario.invalid) {
      this.utilServices.mensajeErroToast("Seleccione el Convoy");
      return;
    }

    let item = this.formDetalle.getRawValue();
    const viajeId = Number(item.viajeId);
    if (!viajeId) return;

    const existe = (this.listAsignaciones || []).some((d) => Number(d.viajeId) === viajeId);
    if (existe) {
      this.utilServices.mensajeErroToast('El viaje ya existe en el detalle');
      return;
    }

    if(!this.isCreate){
      item.idConvoy = this.selected.idConvoy;
      const payload = { ...item };
      delete payload.choferNombre;
      delete payload.nombreProveedor;
      delete payload.furgon;

      this.logisticaAPI.createConvoyDetalle(payload).subscribe((res) => {
        if(res){
          this.utilServices.mensajeOKToast("Detalle de Viaje actualizado");
          this.getDetalles();
          this.listar();
        }
      }, (err) => {
        console.log(err.message);
      });
    }else this.listAsignaciones.push(item);

  }

  getDetalles(){
    this.listAsignaciones = [];

    console.log("selected actual", this.selected);
    let viajeActual = this.selected.detalles[0].idViaje;

      this.logisticaAPI.getByConvoyDetalleViaje(this.selected.detalles[0].viajeId).subscribe((res) => {
        this.listAsignaciones = res;
        console.log("resultado de consulta de carga, ", res);
      }, (err) => {
        console.error(err.message);
        this.listAsignaciones = [];
      });
  }

  deleteDetalle(index, item){
    if(!this.isCreate){
      console.log("detalle a eliminar", item);
      this.logisticaAPI.deleteConvoyDetalle(item).subscribe((res) => {
          this.utilServices.mensajeOKToast("Detalle eliminada exitosamente");
          this.getDetalles();
          this.listar();
      }, (err) => {
        console.warn(err.message);
      });
    }
    else
      console.log("aqui elimina");
      this.listAsignaciones.splice(index, 1);

  }

  //limpiar todas las listAsignaciones
  clearListAsignaciones(){
    this.listAsignaciones = [];
  }



}
